import React from 'react';
import { Box, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import { StatusVariant } from '../utils';

interface Props {
	variant?: StatusVariant;
	statusText: string;
	rightActionBtn?: JSX.Element;
	dataQA?: string;
}

const PaymentStatus = (props: Props) => {
	const { variant, statusText, rightActionBtn, dataQA } = props;
	const classes = useStyles({ variant });
	return (
		<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
			<Box mr={2}>
				<div className={classNames(classes.paymentIndicator, variant ? classes[variant] : null)} />
			</Box>
			<Box flex={1} data-qa={dataQA}>
				<Typography variant="body1" className={classes.statusLabel}>
					{statusText}
				</Typography>
			</Box>
			<Box maxWidth="50%" ml={2}>
				{rightActionBtn}
			</Box>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		paymentIndicator: {
			width: 12,
			height: 12,
			borderRadius: 30,
			backgroundColor: ({ variant }: { variant?: StatusVariant }) => {
				const variantColors: Record<StatusVariant & 'noVariant', string> = {
					neutral: theme.palette.colors.tundra.main,
					warning: theme.palette.warning.main,
					success: theme.palette.success.main,
					danger: theme.palette.error.main,
					noVariant: 'transparent',
				};
				return variantColors[variant ?? 'noVariant'];
			},
		},
		statusLabel: {
			fontWeight: 500,
			padding: theme.spacing(1, 0),
			fontSize: '1.8rem',
		},
		leftIcon: {
			marginRight: theme.spacing(1),
		},
	}),
);

export default PaymentStatus;
